import CancellingLessonsAlert from './CancellingLessonsAlert';

export default CancellingLessonsAlert;
